export const rentAllKey = 'rentAll';
export const rentAllListKey = 'rentAllList';
export const rentKey = 'rent';
export const getRentKey = 'getRent';
export const getRentListKey = 'getRentList';
export const deleteRentKey = 'deleteRent';
export const editRentKey = 'editRent';
export const updateRentKey = 'updateRent';
export const addRentKey = 'addRent';
